import axios from '@/axios'

export default {
  fetchAll(params, id){
    return axios.get(`/receive-details/all/${id}`, {params})
  },
  fetchLimit(params, id){
    return axios.get(`/receive-details/limit/${id}`, {params})
  },  
  fetchById(id){
    return axios.get(`/receive-details/${id}`)
  },    
  create(payload){
    return axios.post(`/receive-details`, payload)
  },
  update(id, payload){
    return axios.put(`/receive-details/${id}`, payload)
  },
  delete(id){
    return axios.delete(`/receive-details/${id}`)
  }, 
  deleteMultiple(payload){
    return axios.delete(`/receive-details`, payload)
  }
}